import ControlledTable from "@/components/controlled-table";
import { useTableServer } from "@/hooks/useTableServer";
import { useMemo } from "react";
import { getColumns } from "./columns";
import FilterElement from "./filter-element";
import InvoiceRepository from "@/utilities/repositories/Invoice";
import { ColumnsType } from "rc-table";
import { IInvoice } from "@/utilities/types/Invoice";

export default function InvoiceTable() {
  const onHeaderCellClick = (value: string) => ({
    onClick: () => {
      handleSort(value);
    },
  });

  const {
    isLoading,
    tableData,
    currentPage,
    totalItems,
    handlePaginate,
    pageSize,
    handleChangePageSize,
    searchTerm,
    handleSearch,
    sortConfig,
    handleSort,
    updateFilter,
    handleReset,
    refresh,
  } = useTableServer({
    server: {
      request: InvoiceRepository.getInvoiceList,
    },
    searchBy: (searchTerm) => {
      const s = searchTerm || undefined;
      return {
        search: s,
      };
    },
  });

  const columns: ColumnsType<IInvoice> = useMemo(
    () =>
      getColumns({
        data: tableData,
        sortConfig,
        onHeaderCellClick,
        handleReset,
        refresh,
      }),
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [onHeaderCellClick, sortConfig.key, sortConfig.direction, tableData]
  );

  return (
    <div className="mt-4">
      <FilterElement
        onSearch={handleSearch}
        searchTerm={searchTerm}
        updateFilter={updateFilter}
      />
      <ControlledTable<IInvoice>
        variant="modern"
        data={tableData}
        isLoading={isLoading}
        showLoadingText={true}
        columns={columns}
        paginatorOptions={{
          pageSize,
          setPageSize: handleChangePageSize,
          total: totalItems,
          current: currentPage,
          onChange: (page: number) => handlePaginate(page),
        }}
        className="rounded-md border border-muted text-sm shadow-sm [&_.rc-table-placeholder_.rc-table-expanded-row-fixed>div]:h-60 [&_.rc-table-placeholder_.rc-table-expanded-row-fixed>div]:justify-center [&_.rc-table-row:last-child_td.rc-table-cell]:border-b-0 [&_thead.rc-table-thead]:border-t-0"
      />
    </div>
  );
}
